import React from "react";
import YellowCardSvg from "../../assets/yellow-card.svg";
import RedCardSvg from "../../assets/red-card.svg";
import BallSvg from "../../assets/Ball.svg";
import OffsideSvg from "../../assets/offside.svg";
import VarSvg from "../../assets/video-assistant-referees.svg";
import SubstitutionSvg from "../../assets/substitution.svg";
import WhistleSvg from "../../assets/finished.svg";
import ShotOnTargetSvg from "../../assets/shot-on-target.svg";
import ShotOffTargetSvg from "../../assets/shot-off-target.svg";
import ExtraTime from "../../assets/extra-time.svg";
import Corner from "../../assets/corner.svg";
import MissedPenalty from "../../assets/penalty-shootout-missed.svg";

const defaultProps = { style: { width: "4vw", height: "4vw" } };

export const makeEventIcons = (
  imgProps: React.ImgHTMLAttributes<HTMLImageElement> = defaultProps
) => ({
  yellow_card: <img src={YellowCardSvg} alt="Yellow Card" {...imgProps} />,
  red_card: <img src={RedCardSvg} alt="Red Card" {...imgProps} />,
  goal: <img src={BallSvg} alt="Goal" {...imgProps} />,
  corner: <img src={Corner} alt="Corner" {...imgProps} />,
  extra_time: <img src={ExtraTime} alt="Extra Time" {...imgProps} />,
  offside: <img src={OffsideSvg} alt="Offside" {...imgProps} />,
  var_review: <img src={VarSvg} alt="Var Review" {...imgProps} />,
  substitution: <img src={SubstitutionSvg} alt="Substitution" {...imgProps} />,
  whistle: <img src={WhistleSvg} alt="Match Started" {...imgProps} />,
  first_half_end: "FH",
  full_time: "FT",
  shot_on: <img src={ShotOnTargetSvg} alt="Shot on target" {...imgProps} />,
  shot_off: <img src={ShotOffTargetSvg} alt="Shot off target" {...imgProps} />,
  penalty_missed: (
    <img src={MissedPenalty} alt="Missed Penalty" {...imgProps} />
  ),
});

const EVENT_ICONS = makeEventIcons();
export default EVENT_ICONS;
